import React, { useEffect, useState } from 'react';
import { useUserStrategies } from '../../../context/UserStrategies';

import { GridWidget } from '../types';
import PriceTargetsList from './PriceTargetsList';
import PriceTargetsHeader from './PriceTargetsHeader';
import { IStrategy } from '../../../types/model';
import { Legend } from '../../Legend/Legend';
import { PriceTargetsLegend } from './PriceTargetsLegend';

interface PriceTargetsProps extends GridWidget {
  options: { strategyId: string };
}

export const StrategyProgress: React.FC<PriceTargetsProps> = ({
  width,
  setLegend,
  options: { strategyId },
}) => {
  const { strategies } = useUserStrategies();

  const strategy: IStrategy = strategies.find(({ id }) => id === strategyId)!;

  const [assetTargetDetails, setAssetTargetDetails] = useState<JSX.Element>();

  useEffect(() => {
    setLegend &&
      setLegend(
        <Legend CustomLegend={PriceTargetsLegend} collapsed={width === 1} />
      );
  }, [setLegend, width]);

  return (
    assetTargetDetails || (
      <div className="flex flex-col w-full h-full overflow-x-hidden">
        <PriceTargetsHeader strategy={strategy} width={width} />

        <div
          className={`
            flex
            flex-col
            overflow-y-scroll
            overflow-x-hidden
            bg-grey-5
            border-t
            border-grey-10
            dark:bg-grey-90
            dark:border-grey-70
          `}
        >
          <PriceTargetsList
            setAssetTargetDetails={setAssetTargetDetails}
            strategyAssets={strategy.strategyAssets.items}
            currency={strategy.currency}
            width={width}
          />
        </div>
      </div>
    )
  );
};
